<script>
// import { formatMonto } from "@/utils";

export default {
  name: "Hyperlink",
  functional: true,
  props: {
    openSelect: {
      type: Function
    },
    row: {
      type: Object
    },
    column: {
      type: String
    },
    rowValue: {
      type: [String, Number, Object, Array, Function],
      require: false
    },
    getType: {
      type: Function,
      require: false
    },
    month: {
      type: Number,
      require: false
    },

    isTotal: {
      type: Boolean,
      default: false
    }
  },

  render(createElement, context) {
    const { isTotal } = context.props;
    function getColor(props) {
      const { month } = context.props;
      const Januarypedding = props.row.JaPeding;
      const FebruaryPeding = props.row.FaPeding;
      const MarchPeding = props.row.MaPeding;
      const AprilPeding = props.row.aprilPeding;
      const MayPeding = props.row.MayPeding;
      const JunePeding = props.row.JuniPeding;
      const JulyPeding = props.row.juliPeding;
      const AugustPeding = props.row.AugusPeding;
      const SeptemberPeding = props.row.septPeding;
      const OctoberPeding = props.row.octuPeding;
      const NovemberPeding = props.row.novPeding;
      const DecemberPeding = props.row.decPeding;

      if (Januarypedding > 0 && month == 1) {
        return "red";
      }

      if (FebruaryPeding > 0 && month == 2) {
        return "red";
      }
      if (MarchPeding > 0 && month == 3) {
        return "red";
      }
      if (AprilPeding > 0 && month == 4) {
        return "red";
      }
      if (MayPeding > 0 && month == 5) {
        return "red";
      }
      if (JunePeding > 0 && month == 6) {
        return "red";
      }
      if (JulyPeding > 0 && month == 7) {
        return "red";
      }
      if (AugustPeding > 0 && month == 8) {
        return "red";
      }
      if (SeptemberPeding > 0 && month == 9) {
        return "red";
      }
      if (OctoberPeding > 0 && month == 10) {
        return "red";
      }
      if (NovemberPeding > 0 && month == 11) {
        return "red";
      }
      if (DecemberPeding > 0 && month == 12) {
        return "red";
      }

      return "";
    }
    function displayValue(props) {
      if (!props.getType) {
        const value = props.row[props.column];

        if (value == "0" || value == "0.00") {
          return "";
        }

        return value;
      }

      //const type = props.getType();
      //const column = `${props.column}${type !== "quantity" ? "Amount" : ""}`;
      const value = props.row[props.column];

      if (value == "0" || value == "0.00") {
        return "";
      }

      // if (type === "amount") {
      //   return formatMonto(value);
      // }

      return value;
    }

    if (isTotal) {
      return createElement("span", {}, displayValue(context.props));
    }

    return createElement(
      "a",
      {
        attrs: {
          href: "#"
        },
        on: {
          click: () => {
            context.props.openSelect(context.props);
          }
        },

        style: {
          color: getColor(context.props)
        }
      },
      displayValue(context.props)
    );
  }
};
</script>
